export const PAGE_ICONS = [
  "pulse",
  "alert-circle",
  "warning",
  "archive",
  "arrow-back",
  "arrow-down-circle",
  "arrow-back-circle",
  "arrow-forward-circle",
  "arrow-up-circle",
  "arrow-down",
  "arrow-forward",
  "chevron-back",
  "chevron-down",
  "chevron-forward",
  "chevron-up",
  "arrow-up",
  "at",
  "attach",
  "ribbon",
  "backspace",
  "bar-chart",
  "battery-half",
  "logo-behance",
  "notifications-off",
  "notifications",
  "bluetooth",
  "book",
  "bookmark",
  "briefcase",
  "browsers",
  "brush",
  "bulb",
  "calendar",
  "camera",
  "car",
  "tv",
  "battery-charging",
  "checkmark-circle",
  "checkbox",
  "checkmark",
  "clipboard",
  "time",
  "close-circle",
  "close",
  "cloud-download",
  "cloud-upload",
  "code-download",
  "code",
  "contract",
  "color-palette",
  "eyedrop",
  "compass",
  "copy",
  "return-down-back",
  "return-down-forward",
  "return-up-back",
  "return-up-forward",
  "card",
  "crop",
  "cube",
  "trending-down",
  "trending-up",
  "checkmark-done",
  "download",
  "water",
  "create",
  "mail",
  "expand",
  "open",
  "eye-off",
  "eye",
  "logo-facebook",
  "document-attach",
  "document",
  "document-text",
  "film",
  "flag",
  "flash-off",
  "flash",
  "swap-vertical",
  "swap-horizontal",
  "folder-open",
  "folder",
  "funnel",
  "gift",
  "logo-github",
  "earth",
  "globe",
  "logo-google",
  "grid",
  "server",
  "pricetag",
  "headset",
  "heart",
  "home",
  "images",
  "image",
  "file-tray",
  "information-circle",
  "keypad",
  "layers",
  "link",
  "logo-linkedin",
  "list",
  "lock-closed",
  "log-in",
  "log-out",
  "map",
  "menu",
  "chatbubble",
  "chatbox",
  "mic-off",
  "mic",
  "remove-circle",
  "remove",
  "desktop",
  "moon",
  "ellipsis-horizontal",
  "ellipsis-vertical",
  "move",
  "musical-notes",
  "navigate",
  "logo-npm",
  "options",
  "paper-plane",
  "pause-circle",
  "people",
  "calculator",
  "person-add",
  "person-remove",
  "person",
  "call",
  "pie-chart",
  "pin",
  "play-circle",
  "add-circle",
  "add",
  "power",
  "pricetags",
  "print",
  "help-circle",
  "help",
  "radio-button-off",
  "radio-button-on",
  "radio",
  "recording",
  "refresh",
  "repeat",
  "play-back",
  "play-forward",
  "save",
  "cut",
  "search",
  "settings",
  "phone-portrait",
  "share",
  "shield",
  "bag",
  "cart",
  "shuffle",
  "play-skip-back",
  "play-skip-forward",
  "ban",
  "happy",
  "volume-high",
  "square",
  "star",
  "stop-circle",
  "sunny",
  "sync",
  "text",
  "thermometer",
  "toggle",
  "trash",
  "logo-twitter",
  "umbrella",
  "arrow-undo",
  "lock-open",
  "videocam-off",
  "videocam",
  "volume-low",
  "volume-mute",
  "volume-off",
  "wifi",
  "pulse-outline",
  "alert-circle-outline",
  "warning-outline",
  "archive-outline",
  "arrow-back-outline",
  "arrow-down-circle-outline",
  "arrow-back-circle-outline",
  "arrow-forward-circle-outline",
  "arrow-up-circle-outline",
  "arrow-down-outline",
  "arrow-forward-outline",
  "chevron-back-outline",
  "chevron-down-outline",
  "chevron-forward-outline",
  "chevron-up-outline",
  "arrow-up-outline",
  "at-outline",
  "attach-outline",
  "ribbon-outline",
  "backspace-outline",
  "bar-chart-outline",
  "battery-half-outline",
  "notifications-off-outline",
  "notifications-outline",
  "bluetooth-outline",
  "book-outline",
  "bookmark-outline",
  "briefcase-outline",
  "browsers-outline",
  "brush-outline",
  "bulb-outline",
  "calendar-outline",
  "camera-outline",
  "car-outline",
  "tv-outline",
  "battery-charging-outline",
  "checkmark-circle-outline",
  "checkmark-outline",
  "checkbox-outline",
  "clipboard-outline",
  "time-outline",
  "close-circle-outline",
  "close-outline",
  "cloud-download-outline",
  "cloud-upload-outline",
  "code-download-outline",
  "code-outline",
  "contract-outline",
  "color-palette-outline",
  "eyedrop-outline",
  "compass-outline",
  "copy-outline",
  "return-down-back-outline",
  "return-down-forward-outline",
  "return-up-back-outline",
  "return-up-forward-outline",
  "card-outline",
  "crop-outline",
  "cube-outline",
  "trending-down-outline",
  "trending-up-outline",
  "checkmark-done-outline",
  "download-outline",
  "water-outline",
  "create-outline",
  "mail-outline",
  "expand-outline",
  "open-outline",
  "eye-off-outline",
  "eye-outline",
  "document-attach-outline",
  "document-outline",
  "document-text-outline",
  "film-outline",
  "flag-outline",
  "flash-off-outline",
  "flash-outline",
  "swap-vertical-outline",
  "swap-horizontal-outline",
  "folder-open-outline",
  "folder-outline",
  "funnel-outline",
  "gift-outline",
  "earth-outline",
  "globe-outline",
  "grid-outline",
  "server-outline",
  "pricetag-outline",
  "headset-outline",
  "heart-outline",
  "home-outline",
  "image-outline",
  "file-tray-outline",
  "information-circle-outline",
  "keypad-outline",
  "layers-outline",
  "link-outline",
  "list-outline",
  "sync-outline",
  "lock-closed-outline",
  "log-in-outline",
  "log-out-outline",
  "map-outline",
  "menu-outline",
  "chatbubble-outline",
  "chatbox-outline",
  "mic-off-outline",
  "mic-outline",
  "remove-circle-outline",
  "remove-outline",
  "desktop-outline",
  "moon-outline",
  "ellipsis-horizontal-outline",
  "ellipsis-vertical-outline",
  "move-outline",
  "musical-notes-outline",
  "navigate-outline",
  "options-outline",
  "paper-plane-outline",
  "pause-circle-outline",
  "people-outline",
  "calculator-outline",
  "person-add-outline",
  "person-remove-outline",
  "person-outline",
  "call-outline",
  "pie-chart-outline",
  "pin-outline",
  "play-circle-outline",
  "add-circle-outline",
  "add-outline",
  "power-outline",
  "pricetags-outline",
  "print-outline",
  "help-circle-outline",
  "help-outline",
  "radio-button-off-outline",
  "radio-button-on-outline",
  "radio-outline",
  "recording-outline",
  "refresh-outline",
  "repeat-outline",
  "play-back-outline",
  "play-forward-outline",
  "save-outline",
  "cut-outline",
  "search-outline",
  "settings-outline",
  "phone-portrait-outline",
  "share-outline",
  "shield-outline",
  "bag-outline",
  "cart-outline",
  "shuffle-outline",
  "play-skip-back-outline",
  "play-skip-forward-outline",
  "ban-outline",
  "happy-outline",
  "volume-high-outline",
  "square-outline",
  "star-outline",
  "stop-circle-outline",
  "sunny-outline",
  "text-outline",
  "thermometer-outline",
  "toggle-outline",
  "trash-outline",
  "umbrella-outline",
  "arrow-undo-outline",
  "lock-open-outline",
  "videocam-off-outline",
  "videocam-outline",
  "volume-low-outline",
  "volume-mute-outline",
  "volume-off-outline",
  "wifi-outline",
];
